/* eslint-disable max-lines */
/* eslint-disable max-len */

export function ContentLocaleEnGb() {
  return (
    <>
      <div>
        <p className="page-title">
          Data Protection Policy of the Robotics Web Portal
        </p>
        <h2 className="heading-title">
          I. Name and address of the data controller and the data protection
          officer
        </h2>

        <p className="my-20">
          Name and contact details of the data controller:
        </p>
        <p>Kärcher (U.K.) Ltd</p>
        <p>Simon Keeping</p>
        <p>Kärcher (U.K.) Ltd, Kärcher House, Brookhill Way</p>
        <p>OX16 3ED Banbury</p>
        <p>01295 752200</p>
        <p>
          <a href="mailto:enquiries@karcher.co.uk">enquiries@karcher.co.uk</a>
        </p>

        <p className="my-10">
          (hereinafter: Kärcher) shall proceed in accordance with the statutory
          provisions with regard to all data processing operations (e.g.
          collection, processing and transmission).
        </p>

        <p className="my-10">
          The following policy provides you with an overview of the type of data
          collected on and via our web portal at&nbsp;
          <a
            href="https://kira-webportal.ipp.kaercher.com/"
            target="_blank"
            rel="noreferrer noopener">
            https://kira-webportal.ipp.kaercher.com/
          </a>
          &nbsp;(hereinafter: platform) and how they are processed, what
          security measures Kärcher takes to protect your data and how you can
          exercise your rights.
        </p>

        <p className="my-10">
          If you have any questions about data protection and your rights as a
          data subject, you can contact the Kärcher data protection officer at:
        </p>

        <p>Kärcher (U.K.) Ltd</p>
        <p>Data Protection Officer</p>
        <p>Kärcher (U.K.) Ltd, Kärcher House, Brookhill Way</p>
        <p>OX16 3ED Banbury</p>
        <p>
          <a href="mailto:mark.venner@karcher.com">mark.venner@karcher.com</a>
        </p>
      </div>

      <div className="mt-40">
        <h2>II. General information on data processing</h2>

        <h3>1. Scope of the processing of personal data</h3>
        <p>
          Unless otherwise stated, we process your personal data as a user of
          our platform (hereinafter: data subject) in order to be able to
          provide and deliver a functional and user-friendly platform and our
          respective services to you
        </p>

        <h3>2. Legal basis for the processing of personal data</h3>
        <p>
          Insofar as we obtain the consent of the data subject for the
          processing of personal data, Art. 6 (1) (a) of the General Data
          Protection Regulation (GDPR) serves as the legal basis.
        </p>

        <p className="mt-10">
          If the processing of personal data is required for use of the
          platform, Art. 6 (1) (b) GDPR serves as the legal basis. This also
          applies to processing operations that are necessary for the
          implementation of pre-contractual measures.
        </p>
        <p>
          Insofar as the processing of personal data is necessary for the
          fulfilment of a legal obligation to which our company is subject, Art.
          6 (1) (c) GDPR serves as the legal basis.
        </p>

        <p className="mt-10">
          If the processing is necessary to protect a legitimate interest of our
          company or a third party and the interests, fundamental rights and
          freedoms of the data subject do not outweigh the aforementioned
          interest, Art. 6 (1) (f) GDPR serves as the legal basis for the
          processing.
        </p>

        <h3>3. Data erasure and storage period</h3>
        <p>
          Unless otherwise stated, personal data will be blocked or erased as
          soon as the purpose of the storage no longer applies.
        </p>

        <p className="mt-10">
          Furthermore, the data may be stored if this is provided for by the
          European or national legislator in EU regulations, laws or other
          provisions to which the controller is subject. The data will also be
          blocked or erased if a storage period thus prescribed expires, unless
          there is a need for further storage of the data for the conclusion or
          performance of a contract.
        </p>
      </div>

      <div className="mt-40">
        <h2>III. Provision of the platform</h2>

        <h3>1. Description and scope of data processing</h3>
        <p>
          Every time our platform is accessed, our system automatically collects
          data and information from the computer system of the accessing
          computer.
        </p>

        <p className="mt-10">The following data are collected:</p>

        <ul>
          <li>Date and time of request</li>
          <li>Name of the requested file</li>
          <li>Time of the last login</li>
          <li>Page from which the file was requested</li>
          <li>Access status (file transferred, file not found, etc.)</li>
          <li>Web browser and operating system used</li>
          <li>Complete IP address of the requesting computer</li>
          <li>Data volume transferred</li>
          <li>Robotics data, robot route information and maps</li>
        </ul>

        <p>The data are also stored in the log files of our system.</p>

        <h3>2. Legal basis for data processing</h3>
        <p>
          The legal basis for the temporary storage of the data and the log
          files is Art. 6 (1) (f) GDPR.
        </p>

        <h3>3. Purpose of data processing</h3>
        <p>
          Temporary storage of the IP address by the system is necessary to
          enable delivery of the platform to the user’s computer. For this
          purpose, the user’s IP address must remain stored for the duration of
          the session.
        </p>

        <p className="mt-10">
          Storage in log files is carried out in order to ensure the
          functionality of the platform. Furthermore, we use the data to
          optimise the platform and to ensure the security of our IT systems.
        </p>

        <p className="mt-10">
          These purposes also constitute our legitimate interest in data
          processing pursuant to Art. 6 (1) (f) GDPR.
        </p>

        <h3>4. Duration of storage</h3>
        <p>
          The data shall be erased as soon as they are no longer required for
          achieving the purpose for which they were collected.
        </p>
      </div>

      <div className="mt-40">
        <h2>IV. Registration on the platform</h2>

        <h3>1. Description and scope of data processing</h3>
        <p>
          In order to be able to use the platform comprehensively and to
          retrieve the machine data processed for the respective registered
          device(s), registration on the platform and registration of a user
          account is mandatory.
        </p>

        <p className="mt-10">
          The registration of a user account is carried out via a Kärcher
          account, in which users can select a password to use in conjunction
          with their e-mail address (hereinafter: user data). In addition,
          further voluntary information (e.g. company name and contact details)
          can be provided. The data are entered in an input mask and transmitted
          to us and stored.
        </p>

        <p className="mt-10">
          Phone numbers and e-mail addresses can be stored on the platform for
          forwarding messages via SMS or e-mail sent from a device. These are
          stored as so-called operators, where the name, telephone number,
          e-mail address and the respective device from which the messages are
          forwarded are stored.
        </p>

        <h3>2. Legal basis for data processing</h3>
        <p>
          The legal basis for the processing of personal data is the performance
          of a contract (Art. 6 (1) (b) GDPR).
        </p>

        <h3>3. Purpose of data processing</h3>
        <p>
          The creation of a user account is necessary for assignment to the
          respective device or use of the functions provided. The data may
          therefore also be processed when the functions selected by the user
          are used.
        </p>

        <h3>4. Duration of storage</h3>
        <p>
          When you create a user account, we generally store the personal data
          provided for as long as you maintain your user account or until the
          data are changed or deleted in the user account.
        </p>

        <p className="mt-10">
          Please note that deletion of the respective user account on the
          platform may result in the loss of access to the platform and access
          to the stored data.
        </p>

        <h3>5. Possibility of erasure</h3>
        <p>
          Users of the platform have the possibility at any time of modifying or
          erasing the personal data stored there.
        </p>

        <p className="mt-10">
          If the data are required for the performance of a contract or for the
          implementation of pre-contractual measures, early erasure of the data
          is only possible insofar as contractual or legal obligations do not
          prevent erasure.
        </p>
      </div>

      <div className="mt-40">
        <h2>V. Use of cookies</h2>

        <h3>1. Description and scope of data processing</h3>
        <p>
          Our platform uses cookies. Cookies are text files that are stored in
          the Internet browser, or by the Internet browser on the user’s
          computer system. If a user calls up a platform, a cookie may be stored
          in the user’s operating system. This cookie contains a characteristic
          string that enables the browser to be uniquely identified when the
          platform is called up again.
        </p>

        <h3>2. Legal basis for data processing</h3>
        <p>
          The legal basis for the processing of personal data using functionally
          or technically necessary cookies is Art. 6 (1) (f) GDPR.
        </p>

        <h3>3. Purpose of data processing</h3>
        <p>
          The purpose of the use of technically necessary cookies is to simplify
          use of the platform for users. Some functions of our platform cannot
          be offered without the use of cookies. The user data collected by
          means of technically necessary cookies are not used to create user
          profiles. These purposes also constitute our legitimate interest in
          the processing of personal data pursuant to Art. 6 (1) (f) GDPR.
        </p>

        <h3>4. Possibility of objection</h3>
        <p>
          Cookies are stored on the user’s computer and transmitted by it to our
          site. As a user, you thus also have full control over the use of
          cookies. By changing the settings in your Internet browser, you can
          disable or restrict the transmission of cookies. Cookies that have
          already been saved can be deleted at any time. This can also be
          automated. If cookies are disabled for our platform, it may no longer
          be possible to use all functions of the platform to their full extent.
        </p>
      </div>

      <div className="mt-40">
        <h2>VI. Disclosure to third parties</h2>

        <p>
          Within the Kärcher group of companies, we exchange personal data
          within the group insofar as and to the extent this is necessary for
          the processing of contracts or for the implementation of
          pre-contractual measures in accordance with Art. 6 (1) (b) GDPR or if
          there is a justified interest in an intra-group transfer in accordance
          with Art. 6 (1) (f) GDPR.
        </p>

        <p className="mt-10">
          Apart from the cases explicitly mentioned in this data protection
          policy, your personal data will only be passed on to third parties
          without your express prior consent if this is permitted or required by
          law.
        </p>

        <p className="mt-10">
          If required for the clarification of illegal use or misuse of the
          platform, or for prosecution, personal data will be forwarded to law
          enforcement agencies or other authorities and, if applicable, to
          injured third parties. This shall only be carried out, however, if
          there are indications of unlawful or abusive behaviour. We are also
          required by law to provide information to certain public bodies on
          request. These are law enforcement authorities, authorities that
          prosecute administrative offences subject to fines, and tax
          authorities.
        </p>

        <p className="mt-10">
          Any disclosure of personal data is justified by the fact that (1) the
          processing is necessary for compliance with a legal obligation to
          which we are subject pursuant to Art. 6 (1) (c) GDPR in conjunction
          with national legal requirements for the disclosure of data to law
          enforcement authorities, or (2) we have a legitimate interest in
          disclosing the data to the aforementioned third parties if there are
          indications of abusive behaviour or for the enforcement of legal
          claims and your rights and interests in the protection of your
          personal data within the meaning of Art. 6 (1) (f) GDPR do not
          outweigh our legitimate interest.
        </p>

        <p className="mt-10">
          In order to be able to offer the services on this platform,
          third-party companies and external service providers are used. Any
          third-party companies and external service providers used are
          carefully selected as processors within the scope of Art. 28 (1) GDPR,
          regularly checked and contractually obliged to process all personal
          data exclusively in accordance with our instructions.
        </p>
      </div>

      <div className="mt-40">
        <h2>VII. Data transfer to third countries</h2>

        <p>
          Unless otherwise stated, data are only transferred to bodies in
          countries outside the European Union (so-called third countries)
          insofar as
        </p>

        <ul>
          <li>
            this is necessary for execution of your orders (e.g. payment
            orders),
          </li>
          <li>it serves to improve the product,</li>
          <li>an adequate level of data protection is ensured, or</li>
          <li>you have given us your consent.</li>
        </ul>
      </div>

      <div className="mt-40">
        <h2>VIII. Data security</h2>

        <h3>1. General technical and organisational measures</h3>
        <p>
          Kärcher has taken a variety of security measures to protect personal
          information adequately and to the appropriate extent. All data stored
          by Kärcher are protected by physical, technical and procedural
          measures that restrict access to the information to specifically
          authorised persons in accordance with this data protection policy.
        </p>

        <h3>2. Secure data transmission</h3>
        <p>
          The transmission of your personal data in conjunction with an order
          process is encrypted using the industry standard Secure Socket Layer
          (“SSL”) technology, SSL encryption version, or comparable
          technologies.
        </p>

        <h3>3. Passwords</h3>
        <p>
          You should never disclose your password for access to our platform to
          third parties and you should also change it regularly. If you wish to
          exit your user account, you should log out and close your browser to
          avoid anyone gaining unauthorised access to it.
        </p>
      </div>

      <div className="mt-40">
        <h2>IX. Rights of the data subject</h2>

        <h3>1. Right of access</h3>
        <p>
          Pursuant to Art. 15 GDPR, you can request access to your personal data
          that we process.
        </p>

        <h3>2. Right to object:</h3>
        <p>You have the right to object on specific grounds (see point 8).</p>

        <h3>3. Right to rectification:</h3>
        <p>
          If the information concerning you is not (or no longer) correct, you
          can request rectification in accordance with Art. 16 GDPR. If your
          data are incomplete, you can request completion.
        </p>

        <h3>4. Right to erasure:</h3>
        <p>
          You can request the erasure of your personal data in accordance with
          Art. 17 GDPR.
        </p>

        <h3>5. Right to restriction of processing:</h3>
        <p>
          Pursuant to Art. 18 GDPR, you have the right to request restriction of
          the processing of your personal data.
        </p>

        <h3>6. Right to lodge a complaint:</h3>
        <p>
          If you are of the opinion that the processing of your personal data
          violates data protection law, you have the right to lodge a complaint
          with a data protection supervisory authority of your choice or with
          the data protection supervisory authority responsible for the data
          controller in accordance with Art. 77 (1) GDPR.
        </p>

        <h3>7. Right to data portability</h3>
        <p>
          In the event that the requirements of Art. 20 (1) GDPR are met, you
          have the right to have data that we process automatically on the basis
          of your consent or in performance of a contract handed over to you or
          to third parties.
        </p>

        <h3>8. Right to object pursuant to Art. 21 (1) GDPR:</h3>
        <p>
          You have the right to object at any time, on grounds relating to your
          particular situation, to the processing of your personal data which is
          carried out on the basis of Article 6 (1) (f) GDPR. The data
          controller will then no longer process these personal data unless it
          can demonstrate compelling legitimate grounds for the processing which
          override the interests, rights and freedoms of the data subject or for
          the establishment, exercise or defence of legal claims.
        </p>
      </div>

      <div className="mt-40">
        <h2>X. Changes to this data protection policy</h2>

        <p>
          We always keep this data protection policy up to date. We therefore
          reserve the right to update and adapt it from time to time and to
          incorporate any changes in the processing or use of your data. The
          current version of the data protection policy is always available on
          the platform under “Data protection policy”.
        </p>
      </div>
    </>
  );
}
